import React, { useEffect, useState } from "react";
import { getPublicAssetUrl } from "../config/logoSizes";

// One-time intro shown on the FIRST app open of a launch/session only.
// A rotating triangle mark + the word "TaweelAI" revealed letter-by-letter on a
// clean white page, then it fades out and never shows again this session.
//
// "First open only": a module-level flag guards against React re-mounts within the
// same page load, and sessionStorage guards against route changes / remounts that
// keep the tab alive. On a native app, a cold open is a fresh WebView (empty
// sessionStorage) so it plays exactly once per launch — which is what we want.
let shownThisPageLoad = false;

const WORD = "TaweelAI";
const HOLD_MS = 1800;   // total time the intro stays fully visible
const FADE_MS = 500;    // fade-out duration

const IntroSplash = () => {
  const [phase, setPhase] = useState(() => {
    if (shownThisPageLoad) return "done";
    try {
      if (sessionStorage.getItem("taweelai_intro_shown") === "1") return "done";
    } catch (_) {}
    return "show";
  });

  useEffect(() => {
    if (phase !== "show") return;
    shownThisPageLoad = true;
    try { sessionStorage.setItem("taweelai_intro_shown", "1"); } catch (_) {}
    const t1 = setTimeout(() => setPhase("fade"), HOLD_MS);
    const t2 = setTimeout(() => setPhase("done"), HOLD_MS + FADE_MS);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [phase]);

  if (phase === "done") return null;

  return (
    <div className={`intro-splash ${phase === "fade" ? "intro-splash--fade" : ""}`} aria-hidden="true">
      <div className="intro-splash__inner">
        <img
          src={getPublicAssetUrl("collapsed-icon.svg")}
          alt=""
          className="intro-splash__mark"
          draggable={false}
        />
        <div className="intro-splash__word">
          {WORD.split("").map((ch, i) => (
            <span
              key={i}
              className="intro-splash__letter"
              style={{ animationDelay: `${0.35 + i * 0.09}s` }}
            >
              {ch}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IntroSplash;
